<template>
  <loader-wrapper :loading="loading">
    <el-collapse>
      <el-collapse-item
        :title="`Редактировать данные контрагента ${contragent_data.inn}`"
      >
        <form-contragent
          :edit-type="true"
          :contragent-data="contragent_data"
          @saveContragent="actionContargent"
          @checkRs="checkRs"
          @checkBik="checkBik"
        />
      </el-collapse-item>
      <el-collapse-item
        title="Уставные документы (ИНН+ОГРН+Скан паспорта ИП или руководителя)"
      >
        <statutory-documents
          ref="statutoryFiles"
          :contragent="contragent_data"
          :documents-list="statutoryDocuments"
          :documents-headers="statutoryDocumentsHeaders"
          @change-docs="setStatutoryDocs"
          @save-statutories="saveStatutoryDocs"
          @not-saved="resetStatutoryDocs"
        />
      </el-collapse-item>
      <el-collapse-item
        v-for="performer in getOrganizations"
        :key="performer.id"
        :title="`Договор с контрагентом ${performer.short_name}`"
      >
        <contract-contragent
          :key="performer.id"
          ref="contractFiles"
          :performer="performer"
          :contragent="contragent_data"
          @updateContract="$emit('updatedContract')"
        />
      </el-collapse-item>

      <!-- delete legacy -->

      <el-collapse-item v-if="false" title="Заявка на присоединение к договору">
        <sig-join-request ref="sigJoin" :contragent="contragent_data" />
      </el-collapse-item>
      <!-- delete legacy -->

      <el-collapse-item title="Акт признания цифровой подписи">
        <sig-confirm-act ref="sigConfirm" :contragent="contragent_data" />
      </el-collapse-item>
      <el-collapse-item title="Тип налогообложения">
        <taxation-type
          :status="contragent_data.nds_status"
          @set="setTaxationType"
          @save="actionContargent"
        />
      </el-collapse-item>
      <el-collapse-item title="Наемные водители">
        <hired-type
          :status="contragent_data.has_hired_drivers"
          :contragent="contragent_data"
          @set="setHiredType"
          @save="actionContargent"
        />
      </el-collapse-item>
      <el-collapse-item title="Данные по аккредитации">
        <accreditation-wrapper
          v-if="canAction('see_master_approve_wrapper')"
          :entity-id="contragent_data.id || 0"
          link-by-rel="contragents"
          @updateStore="updateStore"
        />
      </el-collapse-item>
    </el-collapse>

    <div slot="footer" class="dialog-footer-contr" />
  </loader-wrapper>
</template>

<script>
import { APPROVEMENTS_CONTRAGENTS } from '@/store/actions/approvements'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { filesValidateMixinParentActions } from '@/mixins/filesValidateMixin'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  statutoryCommonOptions,
  statutoryIndividualOptions,
  statutoryOrganizationOptions,
} from './constants'
import { validateRs } from '@/helpers/validate-req'
import AccreditationWrapper from '@/components/Accreditation/AccreditationWrapper'
import ContractContragent from './ContractContragent'
import FormContragent from '@/components/Contragents/FormContragent'
import HiredType from '@/components/Contragents/HiredType'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import SigConfirmAct from './SigConfirmAct'
import SigJoinRequest from './SigJoinRequest'
import StatutoryDocuments from './StatutoryDocuments'
import TaxationType from '@/components/Contragents/TaxationType'

const Contragents = RepositoryFactory.get('contragents')
const check = RepositoryFactory.get('check')

export default {
  name: 'ContragentEdit',
  components: {
    FormContragent,
    TaxationType,
    HiredType,
    LoaderWrapper,
    StatutoryDocuments,
    ContractContragent,
    SigJoinRequest,
    SigConfirmAct,
    AccreditationWrapper,
  },
  mixins: [filesValidateMixinParentActions],
  props: {
    contragent: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      errorRs: {
        code: 0,
        message: '',
      },
      contragent_data: {},
      statutoryDocuments: {},
      statutoryDocumentsHeaders: {},
      initialStatutoryDocuments: {},
    }
  },
  computed: {
    ...mapGetters({
      isOrgs: 'organizations/isOrgs',
      getOrganizations: 'organizations/getOrganizations',
    }),
  },
  watch: {
    'contragent.inn': {
      immediate: true,
      handler(val) {
        if (!this.isOrgs) {
          this.fetchOrganizations({ can_be_performer: 1 })
        }
        if (this.contragent?.id) {
          this.loading = true
          Contragents.getStatutoryDocumentsList(this.contragent.id)
            .then(res => {
              this.contragent_data = this.contragent
              this.statutoryDocuments = res.data
              this.initialStatutoryDocuments = { ...res.data }
              this.statutoryDocumentsHeaders =
                val.length === 10
                  ? {
                      ...statutoryOrganizationOptions,
                      ...statutoryCommonOptions,
                    }
                  : { ...statutoryIndividualOptions, ...statutoryCommonOptions }
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        }
        if (val) {
          this.loading = true
          Contragents.getContragentByInn(val)
            .then(res => (this.contragent_data = res.data.items[0]))
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        }
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['fetchOrganizations']),
    ...mapMutations(['updateContragent']),
    updateStore(data) {
      this.$store.dispatch(APPROVEMENTS_CONTRAGENTS, data)
    },
    setTaxationType(nds_status) {
      this.contragent_data = { ...this.contragent_data, nds_status }
    },
    setHiredType(has_hired_drivers) {
      this.contragent_data = { ...this.contragent_data, has_hired_drivers }
    },
    checkRs() {
      if (this.contragent_data.checking_account) {
        this.contragent_data.checking_account =
          this.contragent_data.checking_account.replace(/\s/g, '')
      }

      return validateRs(
        this.contragent_data.checking_account,
        this.contragent_data.bik,
        this.errorRs,
      )
    },
    checkBik() {
      check.bik(this.contragent_data.bik).then(response => {
        if (response.data && !response.data.error) {
          this.contragent_data.name_bank = response.data.name
            .split('&quot;')
            .join("'")
          this.contragent_data.core_account = response.data.ks
        } else {
          this.contragent_data.name_bank = 'Банк не найден'
          this.contragent_data.core_account = ''
        }
      })
    },
    setStatutoryDocs(val) {
      this.statutoryDocuments = val
    },
    resetStatutoryDocs() {
      this.statutoryDocuments = { ...this.initialStatutoryDocuments }
    },
    async saveStatutoryDocs() {
      try {
        this.loading = true
        let params = { ...this.statutoryDocuments }

        params.id = this.contragent_data.id
        const { data } = await Contragents.setStatutoryDocuments(params)

        this.$message({
          message: 'Список документов сохранён',
          type: 'success',
        })
        this.initialStatutoryDocuments = { ...data }
      } catch (err) {
        this.errHandler(err)
      } finally {
        this.loading = false
      }
    },
    actionContargent() {
      const refs = ['statutoryFiles', 'contractFiles', 'sigConfirm', 'sigJoin']

      if (!this.checkCountFilesBeforeSave(refs)) {
        return void 0
      }
      // if (this.checkRs()) {
      this.loading = true
      Contragents.putContragents(this.contragent_data)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            this.updateContragent(this.contragent_data)
            this.$message({
              message: 'Контрагент измeнен успешно',
              type: 'success',
            })
          }
        })
        .catch(e => this.isErrors(e))
        .finally(() => (this.loading = false))
      // } else {
      //   this.$message.warning(this.errorRs.message)
      // }
    },
  },
}
</script>

<style lang="sass">
.dialog-footer-contr
  padding-top: 20px
  margin-top: 20px
  border-top: 0.5px solid grey
  display: flex
  justify-content: flex-end
.el-collapse-item__header
  font-weight: 500
  font-size: 16px
  color: #409eff
</style>
